import { Dialog, DialogContent, Divider } from "@mui/material";
import CustomDialogTitle from "../CustomDialogTitle";
import { useTheme } from "@mui/material/styles";

const MessageDialog = ({ isOpen, title, type = "default", id, onClose, maxWidth = "sm", children }) =>
{
    const theme = useTheme();
    const COLOR_LIST = {
        warning: theme.palette.warning.light,
        error: theme.palette.error.light,
        success: theme.palette.success.light,
        info: theme.palette.info.light,
        default: "white",
    };
    return (
        <Dialog open={isOpen} onClose={onClose} aria-describedby={id} maxWidth={maxWidth} fullWidth={true}>
            <CustomDialogTitle title={title} onClose={onClose} type={type} />
            <Divider />
            <DialogContent
                sx={{
                    backgroundColor: COLOR_LIST[type],
                    padding: theme.spacing(4),
                }}
            >{
                    children
                }
                {/* {children ? children :
                    <DialogContentText
                        sx={{
                            color: (theme) =>
                                theme === "default" ? theme.palette.text.primary : "white",
                        }}
                        id={id}
                    >
                        message
                    </DialogContentText>
                } */}
            </DialogContent>
        </Dialog>
    );
};

export default MessageDialog;
